import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Download, DollarSign, ShieldCheck, Heart } from 'lucide-react';
export function Urgency() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-262">
      <div className="text-center mb-8" data-id="element-263">
        <h2 className="text-3xl font-heading font-bold text-brand-dark flex items-center justify-center gap-2" data-id="element-264">
          <span className="text-amber-500" data-id="element-265">⚠️</span> Esta oferta no dura para
          siempre
        </h2>
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="bg-orange-50 rounded-[24px] p-8 md:p-10 border border-orange-200 shadow-md" data-id="element-266">
        <div className="text-center mb-8" data-id="element-267">
          <h3 className="text-xl md:text-2xl font-bold text-orange-600 mb-2" data-id="element-268">
            🔥 PRECIO DE LANZAMIENTO — OFERTA LIMITADA
          </h3>
          <p className="text-brand-secondary text-lg" data-id="element-269">
            El precio normal es <span className="line-through" data-id="element-270">$19.99</span>
          </p>
          <p className="text-2xl font-bold text-brand-dark mt-1" data-id="element-271">
            HOY puedes llevarla por solo{' '}
            <span className="text-brand-accent" data-id="element-272">$11.99</span>
          </p>
        </div>

        <div className="flex justify-center gap-4 mb-10" data-id="element-273">
          <div className="bg-white px-4 py-3 rounded-lg shadow-sm border border-orange-100 text-center min-w-[80px]" data-id="element-274">
            <div className="text-3xl font-bold text-orange-500 font-mono" data-id="element-275">
              {formatTime(timeLeft.hours)}
            </div>
            <div className="text-xs text-orange-400 uppercase font-bold mt-1" data-id="element-276">
              Horas
            </div>
          </div>
          <div className="text-3xl font-bold text-orange-300 self-center" data-id="element-277">
            :
          </div>
          <div className="bg-white px-4 py-3 rounded-lg shadow-sm border border-orange-100 text-center min-w-[80px]" data-id="element-278">
            <div className="text-3xl font-bold text-orange-500 font-mono" data-id="element-279">
              {formatTime(timeLeft.minutes)}
            </div>
            <div className="text-xs text-orange-400 uppercase font-bold mt-1" data-id="element-280">
              Min
            </div>
          </div>
          <div className="text-3xl font-bold text-orange-300 self-center" data-id="element-281">
            :
          </div>
          <div className="bg-white px-4 py-3 rounded-lg shadow-sm border border-orange-100 text-center min-w-[80px]" data-id="element-282">
            <div className="text-3xl font-bold text-orange-500 font-mono" data-id="element-283">
              {formatTime(timeLeft.seconds)}
            </div>
            <div className="text-xs text-orange-400 uppercase font-bold mt-1" data-id="element-284">
              Seg
            </div>
          </div>
        </div>

        <div className="bg-white rounded-[16px] p-6 shadow-sm border border-orange-100" data-id="element-285">
          <ul className="space-y-4" data-id="element-286">
            <li className="flex items-start gap-3" data-id="element-287">
              <Download className="w-5 h-5 text-orange-500 shrink-0 mt-0.5" data-id="element-288" />
              <span className="text-brand-dark" data-id="element-289">
                <span className="font-bold" data-id="element-290">Descarga instantánea</span> — la
                tienes en 2 minutos
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-291">
              <DollarSign className="w-5 h-5 text-orange-500 shrink-0 mt-0.5" data-id="element-292" />
              <span className="text-brand-dark" data-id="element-293">
                <span className="font-bold" data-id="element-294">Ahorras $8.00</span> con el precio
                de lanzamiento
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-295">
              <ShieldCheck className="w-5 h-5 text-orange-500 shrink-0 mt-0.5" data-id="element-296" />
              <span className="text-brand-dark" data-id="element-297">
                <span className="font-bold" data-id="element-298">
                  Tienes 7 días de garantía total
                </span>
                , sin riesgo
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-299">
              <Heart className="w-5 h-5 text-brand-primary shrink-0 mt-0.5" data-id="element-300" />
              <span className="text-brand-dark font-medium text-brand-primary" data-id="element-301">
                Tu salud vale mucho más que $11.99
              </span>
            </li>
          </ul>
        </div>
      </motion.div>
    </section>;
}